'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const CloseIcon = require('dibs-vg/dist/react/close');

const addEllipsis = require('../../global/utils/addEllipsis.es').default;

function QuickView(props) {
    const { classes, isActive, onClose, ...data } = props;
    const titleCharLimit = 50;
    const descriptionCharLimit = 185;

    let { attributes } = data;
    if (
        attributes !== null &&
        typeof attributes === 'object' &&
        !!attributes.material_techniques_list
    ) {
        attributes = attributes.material_techniques_list;
    }

    const className = classNames(classes.view, {
        [classes.isActive]: isActive,
    });

    return (
        <div className={className}>
            <div onClick={onClose} className={`${classes.view}-close`}>
                <CloseIcon />
            </div>

            <div className={`${classes.view}-title`}>
                <a href={data.uri}>{addEllipsis(data.title, titleCharLimit)}</a>
            </div>

            {data.location ? (
                <div className={`${classes.view}-location`}>{data.location}</div>
            ) : data.creators ? (
                <div className={`${classes.view}-creators`}>{data.creators}</div>
            ) : null}

            {attributes && typeof attributes === 'string' ? (
                <div className={`${classes.view}-attributes`}>{attributes}</div>
            ) : null}

            {data.materials ? (
                <div className={`${classes.view}-materials`}>{data.materials}</div>
            ) : null}

            <div className={`${classes.view}-description`}>
                {addEllipsis(data.description, descriptionCharLimit)}
            </div>
        </div>
    );
}

QuickView.defaultProps = {
    classes: {
        view: 'product-quick-view',
        isActive: 'is-active',
    },
    isActive: false,
    onClose: () => {},
};

QuickView.propTypes = {
    classes: PropTypes.shape({
        view: PropTypes.string.isRequired,
        isActive: PropTypes.string.isRequired,
    }).isRequired,
    isActive: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,

    uri: PropTypes.string,
    title: PropTypes.string,
    location: PropTypes.string,
    creators: PropTypes.string,
    seller: PropTypes.string,
    attributes: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    materials: PropTypes.string,
    description: PropTypes.string,
};

module.exports = QuickView;



// WEBPACK FOOTER //
// ./assets/js/components/ProductQuickView/QuickView.jsx